<template>
    <PlantConfigurationUnits :plantID="plantID"></PlantConfigurationUnits>
</template>

<script>
import PlantConfigurationUnits from '@/components/plants/configuration/PlantConfigurationUnits.vue';

export default {
    components: {
        PlantConfigurationUnits
    },
    data() {
        return {
            
        };
    },
    computed: {
        plantID() {
            return parseInt(this.$route.params.plantID);
        }
    },
    methods: {

    },
    created() {
        
    }
}
</script>

<style>

</style>
